export default "__VITE_ASSET__e76d1fe0__"